import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Header from '../../components/Header/Header';
import './SignIn.css';

function SignIn(): React.ReactElement {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    signIn(email, password);
    navigate('/');
  };

  return (
    <div className="signin-page">
      <Header />
      <main className="signin-main">
        <div className="signin-card">
          <h1 className="signin-title">Sign In</h1>
          <p className="signin-subtitle">Welcome back to Trupz Looplet</p>
          <form className="signin-form" onSubmit={handleSubmit}>
            <div className="signin-field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>
            <div className="signin-field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            <button type="submit" className="signin-btn">
              Sign In
            </button>
          </form>
          <p className="signin-footer">
            Don&apos;t have an account?{' '}
            <Link to="/signup" className="signin-link">Create one</Link>
          </p>
        </div>
      </main>
    </div>
  );
}

export default SignIn;
